export const paytableSettings = {
  leftOffsetLand: -100,
  rightOffsetLand: 100,
  leftOffsetPort: -250,
  rightOffsetPort: -170,
}
